import {CheckoutSlot} from '../CheckoutSlot';
import {SlotId} from '../../../domain/utils/slotId';
import {SummaryTitle} from './SummaryTitle/SummaryTitle';
import {LineItemSection} from './LineItemSection/LineItemSection';
import {CouponInput} from './CouponInput/CouponInput';
import {GiftCardInput} from './GiftCardInput/GiftCardInput';
import {TotalsSection} from './TotalsSection/TotalsSection';
import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes, st} from './CartSummary.st.css';
import {BiMobilePosition} from '../../../domain/utils/bi.util';

export const CartSummary = ({
  className,
  showSlots,
  mobilePosition,
  showLineItems = true,
  showTitle = true,
  shouldShowNumberOfItems = true,
}: {
  className?: string;
  showSlots?: boolean;
  shouldShowNumberOfItems?: boolean;
  showLineItems?: boolean;
  showTitle?: boolean;
  mobilePosition?: BiMobilePosition;
}) => {
  const {
    checkoutStore: {shouldShowGiftCardSection, shouldShowCouponSection},
  } = useControllerProps();
  return (
    <div className={st(classes.summary, className)}>
      {showTitle && <SummaryTitle shouldShowNumberOfItems={shouldShowNumberOfItems} />}
      {showLineItems && <LineItemSection />}
      {showSlots && <CheckoutSlot className={classes.slotWrapper} slotId={SlotId.AfterLineItemsSummaryCheckoutSlot} />}
      {showSlots && <CheckoutSlot className={classes.slotWrapper} slotId={SlotId.AfterLineItems2SummaryCheckoutSlot} />}
      <div className={classes.couponAndGiftCard}>
        {shouldShowCouponSection && <CouponInput mobilePosition={mobilePosition} />}
        {shouldShowGiftCardSection && <GiftCardInput mobilePosition={mobilePosition} />}
      </div>
      {showSlots && (
        <CheckoutSlot className={classes.slotWrapper} slotId={SlotId.BeforeTotalsBreakdownSummaryCheckoutSlot} />
      )}
      <TotalsSection />
    </div>
  );
};
